import React, { useEffect, useState } from "react";
import { Button, Divider, Typography, Grid } from "@mui/material";
import { addOrder, addOrderEntry, getAllOrders } from "../../api/order.api";
import CreateOrderModal from "../../components/modals/createOrder.modal";
import { useAuth } from "../../context/auth.context";
import OrderCard from "../../components/cards/order.card";
import PlaceOrderModal from "../../components/modals/placeOrder.modal";
import { useWebSocket } from "../../context/websocket.context";
import { useSnackbar } from "../../context/snackbar.context";

const OrderPage = () => {
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openPlaceModal, setOpenPlaceModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [orders, setOrders] = useState([]);
  const [selected, setSelected] = useState("");
  const auth = useAuth();
  const websocket = useWebSocket();
  const showSnackbar = useSnackbar();

  useEffect(() => {
    if (!websocket || !websocket.message) {
      return;
    }
    if (websocket.message.Type !== "Order") {
      return;
    }
    setRefresh((prev) => !prev);
  }, [websocket]);

  useEffect(() => {
    getAllOrders().then((response) => {
      setOrders(response.data);
    });
  }, [refresh]);

  const handleCreateSubmit = (formData) => {
    addOrder(formData)
      .then(() => {
        showSnackbar("Created Order!", "success");
      })
      .catch((error) => {});
  };

  const handleOpenCreateModal = () => {
    setOpenCreateModal(true);
  };

  const handleCloseCreateModal = () => {
    setOpenCreateModal(false);
  };

  const handlePlaceSubmit = (formData) => {
    setSelected("");
    addOrderEntry(selected, { ...formData, userId: auth.user.id })
      .then(() => {
        showSnackbar("Entry added!", "success");
      })
      .catch((error) => {});
  };

  const handleOpenPlaceModal = (id) => {
    setSelected(id);
    setOpenPlaceModal(true);
  };

  const handleClosePlaceModal = () => {
    setSelected("");
    setOpenPlaceModal(false);
  };

  const handleRefresh = () => {
    setRefresh((prev) => !prev);
  };

  return (
    <div>
      <Typography variant="h3" gutterBottom>
        Orders
      </Typography>

      {auth && auth.user && auth.user.role === "Admin" && (
        <Button
          variant="contained"
          onClick={handleOpenCreateModal}
          sx={{ mt: 1 }}
        >
          Create Order
        </Button>
      )}

      <Divider sx={{ mt: 1, mb: 1 }} />

      <Grid container spacing={1}>
        {orders.map((order) => (
          <Grid key={order.id} xs={12} sm={6} md={4}>
            <OrderCard
              order={order}
              onAdd={() => handleOpenPlaceModal(order.id)}
              refresh={handleRefresh}
            />
          </Grid>
        ))}
      </Grid>

      <CreateOrderModal
        aria-modal
        open={openCreateModal}
        handleClose={handleCloseCreateModal}
        handleSubmit={handleCreateSubmit}
      />

      <PlaceOrderModal
        aria-modal
        open={openPlaceModal}
        handleClose={handleClosePlaceModal}
        handleSubmit={handlePlaceSubmit}
      />
    </div>
  );
};

export default OrderPage;
